module.exports = __webpack_public_path__ + "static/img/chuzhongshuxue6.879c8b99.jpg";